import type { GroupExtension as GroupExtensionModel } from '@/adapters/catalogv1.g';

export function extractGroupExtension(model: GroupExtensionModel) {
  const attributes = model.attributes ?? [];

  return {
    id: model._metadata?.distinct_id ?? '',
    groupRef: model.group_ref ?? '',
    attributes,
    attributeCount: attributes.length,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroupExtension = ReturnType<typeof extractGroupExtension>;
